import type React from 'react';
import { graphql, usePreloadedQuery, type PreloadedQuery } from 'react-relay';
import type {
	GSNQueryPreloaderQuery,
	GSNQueryPreloaderQuery$data,
} from './__generated__/GSNQueryPreloaderQuery.graphql.ts';

interface QueryRefProps {}

interface GSNQueryPreloaderProps extends QueryRefProps {
	queryReference: PreloadedQuery<GSNQueryPreloaderQuery>;
	render: (props: { queryReference: GSNQueryPreloaderQuery$data }) => React.JSX.Element;
}

export function GSNQueryPreloader(props: GSNQueryPreloaderProps): React.JSX.Element {
	const { queryReference, render } = props;
	const queryRef = usePreloadedQuery<GSNQueryPreloaderQuery>(
		// Need to disable this rule for the useNetworkSideNavUserData fragment (which is inside GSN)
		/* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */
		graphql`
			query GSNQueryPreloaderQuery(
				$cloudId: ID!
				$currentURL: URL
				$entityAriApps: ID
				$entityAriFilters: ID
				$entityAriPlans: ID!
				$entityAriRoadmaps: ID
				$entityAriUserSideNavSettings: ID!
				$isAppsExpanded: Boolean = false
				$isFiltersExpanded: Boolean = false
				$isPlansExpanded: Boolean = false
				$isProjectsExpanded: Boolean = false
				$isOperationsExpanded: Boolean = false
				$navPlatSidebarDataEntityAri: ID!
				$navPlatMenuDataEntityAri: ID!
				$ownerAri: ID
				$isRoadmapUpsellEnabled: Boolean!
				$fetchGlobalShortcutsAvailableProducts: Boolean!
			) {
				...GSNForContentSidebarEntryPoint
				...GSNForOtherSidebars
			}
		`,
		queryReference,
	);

	return render({ queryReference: queryRef });
}
